import { render, staticRenderFns } from "./NoDebtCertificate.vue?vue&type=template&id=3619a8c4&scoped=true&"
import script from "./NoDebtCertificate.vue?vue&type=script&lang=js&"
export * from "./NoDebtCertificate.vue?vue&type=script&lang=js&"
import style0 from "./NoDebtCertificate.vue?vue&type=style&index=0&id=3619a8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619a8c4",
  null
  
)

export default component.exports